import React from "react";

export function TablePaginationArrowLeft(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#CBD5E1" />
      <path
        d="M15.6128 20.6371L15.6128 20.637C15.529 20.5536 15.4625 20.4544 15.4172 20.3452C15.3719 20.236 15.3485 20.1189 15.3485 20.0006C15.3485 19.8824 15.3719 19.7653 15.4172 19.6561C15.4625 19.5469 15.529 19.4477 15.6128 19.3643L15.6128 19.3642L21.8628 13.1142C22.0316 12.9454 22.2605 12.8506 22.4992 12.8506C22.738 12.8506 22.9669 12.9454 23.1357 13.1142C23.3045 13.283 23.3993 13.5119 23.3993 13.7506C23.3993 13.9894 23.3045 14.2183 23.1357 14.3871L17.5505 19.9722L17.5229 19.9999L17.5505 20.0275L23.1357 25.6142L23.1633 25.5866L23.1357 25.6142C23.3045 25.783 23.3993 26.0119 23.3993 26.2506C23.3993 26.4894 23.3045 26.7183 23.1357 26.8871C22.9669 27.0559 22.738 27.1507 22.4992 27.1507C22.2605 27.1507 22.0316 27.0559 21.8628 26.8871L15.6128 20.6371Z"
        fill="#1E293B"
        stroke="#1E293B"
        strokeWidth="0.078125"
      />
    </svg>
  );
}
